var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen flex flex-col overflow-hidden"},[_c('Header'),_c('RouterView',{staticClass:"flex-grow overflow-y-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }